var React = require('react');

function Advanced (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24.36,53.5 C38.48,53.5 54.74,53.13 57.86,36.25 C60.98,19.36 47.10,0 31.62,0 C16.14,0 4.54747351e-13,14.79 4.54747351e-13,28.97 C4.54747351e-13,43.15 10.25,53.5 24.36,53.5 Z","id":"Oval","fill":"#FFF1D1","key":0}),React.createElement("g",{"id":"zap","transform":"translate(20.250000, 16.750000)","stroke":"#FF9429","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","key":1},React.createElement("polygon",{"id":"Path","points":"10 0 0 12 9 12 8 20 18 8 9 8"}))]);
}

Advanced.defaultProps = {"width":"59px","height":"54px","viewBox":"0 0 59 54","version":"1.1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"};

module.exports = Advanced;

Advanced.default = Advanced;
